//attach-property
//doc-upload
import React from 'react'
import Layout from '../../components/Layout'
import ScrollToTop from '../../components/ScrollToTop'
import SessionCheck from '../../components/SessionCheck'
import NavHeader from '../../components/NavHeader'
import ExtPropertyEligibilityView from '../../views/MortgageView/ext-property-eligibility'

const ExternalPropertyEligibility = () => {
  return (
    <Layout>
    <ScrollToTop />
    <SessionCheck shouldRedirect />
    <NavHeader pageTitle="Mortgage" routeName="mortgage" />
    <ExtPropertyEligibilityView />
  </Layout>
  )
}

export default ExternalPropertyEligibility